import Promo from "./assets/img/1wash-flyers.png";
import Card from "./assets/img/1wash-card.png";
import "./App.css";

function App() {
  return (
    <div className="App">
      <img src={Promo} alt="1wash Promo" width="550" className="promo-img" />

      <br />

      <img src={Card} alt="1wash card" width="550" className="card-img" />
    </div>
  );
}

export default App;
